// extracted by mini-css-extract-plugin
module.exports = {"result":"LrvResult_result__2ILBm","lightResult":"LrvResult_lightResult__2h-g7","darkResult":"LrvResult_darkResult__28Pnd"};